import React from "react";
import "./TestResultCard.scss";
import { Button, Card, CardContent } from "@material-ui/core";
import translate from "../../../i18n/translate";
import TestResultCardChip from "../TestResultCardChip/TestResultCardChip";
import { TestResultCardInterface, TestResultsSectionInterface } from "../../../interfaces";
import moment from "moment";
import { productList } from "../../../globalConstants";

const TestResultCard = (props: TestResultCardInterface) => {  
  const toecsIds: any = JSON.parse(process.env.REACT_APP_TOEICTOEFLIDS || "") || [{}];
  const appendRedirectPortalURL = (redirectURL: string, portalLogin: string) => {
    if (!!redirectURL.match(/.learnship./g)) {
      return redirectURL;
    } else {
      if (!!redirectURL.match(/reach/g)) {
        return redirectURL
      }
      return portalLogin + "&redirect=" + encodeURIComponent(redirectURL);
    }
  }
  const formatDate = (dateString: string) => {
    return dateString ? moment(dateString).format('MMM DD, YYYY') : '----';
  }
  const redirectToStep = () => {
    if(props.portalLoginURL){
      const stepRawRedirectUrl = `${process.env.REACT_APP_PRODUCT_URL_ID_6}/#/results?attemptId=${props.result.attempt_id}`;    
      window.open(`${appendRedirectPortalURL(stepRawRedirectUrl,props.portalLoginURL)}`,"_self");
    } else {
      return false;
    }
  }

  const getAppropriateText = (id: number) =>{
    const appropriateProductName = props.result.product_name;
    if(appropriateProductName != undefined && appropriateProductName.length > 0){
      return id == 2 ? ("Level Progress Test (" + appropriateProductName + ")") : ("Placement Test (" + appropriateProductName + ")");
    }
  };

  return (
    <Card className="test-results-card">
      <CardContent className="completion-card-body">
        <div className="test-results-container">
          <div className="test-results-details-container">
            <div className="test-results-details-row">
              <div className="test-details-container">
                <div className="test-results-heading">{props.result.test_id == 2 ? getAppropriateText(2) :(props.result.test_id == 1 ? getAppropriateText(1) : props.result.test_name) }</div>
                <div className="test-details-cover">
                   <TestResultCardChip title={translate("progress_totalscore")} titleData={props.result.total_score || ""} />
                  {
                    (props.result.test_id === 6 || props.result.test_id === 8) && !!! sessionStorage.getItem("isDemoUser") && (
                      <Button onClick={redirectToStep} className="test-result-viewscore-btn" color="primary">{translate("progress_button_viewscore")}</Button>
                    )
                  }                  
                </div>
              </div>
            </div>
            <div className="test-results-details-row">
              <div className="test-details-container">
                <div className="test-details-cover">
                  {
                    props.result.test_section_scores && (
                      props.result.test_section_scores.map((chip: TestResultsSectionInterface)=>{
                        return <TestResultCardChip title={chip.section} titleData={chip.score} />;                        
                      })
                    )
                  }                  
                </div>
              </div>
            </div>
            <div className="test-results-details-row no-border">
              <div className="test-details-container">             
                  {
                    ((toecsIds.indexOf(props.result.test_id) < 0)) && (props.result.test_level >= 0) && (
                      props.result.test_level &&
                      <div className="test-details-cover fluid">
                      <TestResultCardChip title={translate("progress_placedText")} titleData={`Level ${props.result.test_level}`} />
                      </div>
                    )
                  }                
                <div className="test-details-cover fluid">
                  <TestResultCardChip  title={translate("progress_testresults_table_date")} titleData={formatDate(props.result.completed_date || "")}/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default TestResultCard;
